import {FileReference} from "../OiReport";

export class EventReport {
    testName: string = "";
    startTime: string = "";
    endTime: string = "";
    elementName: string = "";
    comment: string = "";
    tags: string[] = [];
    taggedUsers: string[] = [];
    taggedElements: string[] = [];
    referencedDocuments: FileReference[] = [];
    dataMatrixCodes: string[] = [];
    taggedElementsComments: string[] = [];
    taggedElementsStart: string[] = [];
    taggedElementsEnd: string[] = [];
    author: string = "";
    testSelection: string = "";
    guid: string = "";
    isDraft: boolean = true;
    isCloned?: boolean = false;
    oiType: number = 0;
    createdAt?: string;
}

export interface Tag{
    name: string;
    isCustom: boolean;
    isToggled: boolean;
}